import React from 'react';
import { Loader2 } from "lucide-react";

const Loading = ({ 
  message = "Loading...", 
  subMessage = "Please wait while we process your request...",
  open = true 
}) => {
  if (!open) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[1300] flex flex-col items-center justify-center gap-6 bg-black/80 text-white">
      <Loader2
        className="h-[60px] w-[60px] animate-spin"
        style={{ color: "var(--education-primary, #746EAC)" }}
        aria-hidden="true"
      />
      <div className="text-center">
        <h2 className="mb-1 text-2xl font-bold" style={{ fontFamily: 'Verdana, Geneva, Tahoma, sans-serif' }}>
        {message}
        </h2>
        <p className="max-w-[400px] text-white/80" style={{ fontFamily: 'Verdana, Geneva, Tahoma, sans-serif' }}>
          {subMessage}
        </p>
      </div>
    </div>
  );
};

export default Loading;
